import { PhaseInput, StoryLevelData } from "@/app/lib/levels/story-level-data-types";

const phaseInputs: PhaseInput[] = [];

phaseInputs.push(new PhaseInput(
    [   'KalE',
        'lEttUcE',
        'aRUgUla',
    ],
    'latgc'
))

phaseInputs.push(new PhaseInput(
    [
        'TomATo',
        'cArroT',
        'cUcUmBEr',
        'jIcAmA'
    ],
    'rmocj'
))

phaseInputs.push(new PhaseInput(
    [
        'AlMonD',
        'CroUTon',
        'oIl',
        'vInAGEr'
    ],
    'rnovl'
))

export const salad = new StoryLevelData('word salad', 'salad-0.0', phaseInputs);